module.exports = __webpack_public_path__ + "img/ic_16_check_white.6cb2f12e.svg";